import React from 'react';
import { Grid, Icon, Tab } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';

import { requestNames } from '../logic/NameService';
import { ValueType } from '../ws/value';
import { ValueList } from '../ws/valueList';
import { NameListUI } from './NameListUI';
import { Culture } from './Culture';

import '../ws/worldspinner.css';
import './Names.css';

interface Props {
}
interface State {
    startupErr?: string;
    userErr?: string;
    mounted?: boolean;
    examples?: ValueList;
    cultureValue?: string;
    loading?: boolean;
}

export class NamesWidget extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            cultureValue: "1",
        };
    }

    public render() {
        return <div>
            <div id="names-widget">
                <Culture onChangeCulture={(cultureValue: string) => this.onChangeCulture(cultureValue)} />

                {this.renderNames()}
            </div>
        </div>;
    }

    private onChangeCulture(cultureValue: string) {
        if (cultureValue !== "-") {
            this.getNames(cultureValue);
            this.setState({ cultureValue });
        }
    }

    private renderNames() {
        if (!this.state.examples) {
            return <div id="names-loading"><Icon name="spinner" size="huge" loading={true} /></div>;
        }
        return <div>
            {this.renderNamesMobile()}
            {this.renderNamesDesktop()}
        </div>;
    }

    private renderNamesMobile() {
        const panes = [
            {
                menuItem: 'Female',
                render: () => <Tab.Pane attached={true}>
                    {this.renderNameColumnMobile("Female", ValueType.FEMALE, this.state.examples!.entries[ValueType.FEMALE])}
                </Tab.Pane>,
            },
            {
                menuItem: 'Male',
                render: () => <Tab.Pane attached={true}>
                    {this.renderNameColumnMobile("Male", ValueType.MALE, this.state.examples!.entries[ValueType.MALE])}
                </Tab.Pane>,
            },
            {
                menuItem: 'City',
                render: () => <Tab.Pane attached={true}>
                    {this.renderNameColumnMobile("Cities", ValueType.CITY, this.state.examples!.entries[ValueType.CITY])}
                </Tab.Pane>,
            },
            {
                menuItem: 'Nation',
                render: () => <Tab.Pane attached={true}>
                    {this.renderNameColumnMobile("Nations", ValueType.NATION, this.state.examples!.entries[ValueType.NATION])}
                </Tab.Pane>,
            },
        ];

        return <div id="names-mobile">
            < Tab menu={{ secondary: true, pointing: true }} panes={panes} />
        </div>;
    }

    private renderNameColumnMobile(label: string, valueType: ValueType, names: string[]) {
        if (!this.state.examples) {
            return <div />;
        }
        return <NameListUI
            // wsClient={this.props.wsClient}
            // wsClient={undefined}
            // label={label}
            names={this.state.examples.entries[valueType]}
            nbrShown={20}
        />;
    }


    private renderNamesDesktop() {
        return <div id="names-desktop">
            <Grid stackable columns={4}>
                {!this.state.examples
                    ? this.state.loading && <div id="names-loading"><Icon name="spinner" size="huge" loading={true} /></div>
                    : <Grid.Row>
                        {this.renderNameColumnDesktop("Female", ValueType.FEMALE, this.state.examples.entries[ValueType.FEMALE])}
                        {this.renderNameColumnDesktop("Male", ValueType.MALE, this.state.examples.entries[ValueType.MALE])}
                        {this.renderNameColumnDesktop("City", ValueType.CITY, this.state.examples.entries[ValueType.CITY])}
                        {this.renderNameColumnDesktop("Nation", ValueType.NATION, this.state.examples.entries[ValueType.NATION])}
                    </Grid.Row>
                }
            </Grid>
        </div>;
    }

    private renderNameColumnDesktop(label: string, valueType: ValueType, names: string[]) {
        return (
            <Grid.Column>
                {!this.state.examples ? "" :
                    <NameListUI
                        // wsClient={this.props.wsClient}
                        // wsClient={undefined}
                        label={label}
                        names={this.state.examples.entries[valueType]}
                        nbrShown={20}
                    />
                    // <div>TEST</div>
                }
            </Grid.Column>
        );
    }

    public async componentDidMount() {
        await this.getNames("1");
    }

    private async getNames(cultureValue: string) {
        this.setState({ loading: true });
        try {
            const names = await requestNames(cultureValue) as any;
            if (!names) {
                throw new Error("getNames: unknown cultureValue " + cultureValue);
            }
            this.setState({
                examples: {
                    entries: {
                        "Female": names.personalFemale,
                        "Male": names.personalMale,
                        "City": names.cities,
                        "Nation": names.nations,
                    }
                }
            });
        } catch (e) {
            console.error("NamesWidget: ERROR getting names: ", e);
        }
        this.setState({ loading: true });
    }

}